<template>
  <h4 :class="customHeadingClass">
    <div class="item-label">
      <slot/>
    </div>
  </h4>
</template>

<script>
export default {
  name: 'ItemHeading',
  props: {
    level: {
      type: String,
      required: true
    }
  },
  computed: {
    customHeadingClass() {
      return `heading-${this.level}`
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
h4 {
  margin-bottom: 20px;
  border-top: 4px solid;
  .item-label {
    color: white;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    padding: 0.4rem 0.6rem;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  &.heading-1st {
    border-color: @tealObjective;
    .item-label {
      background: @tealObjective;
    }
  }
  &.heading-2nd {
    border-color: @blueObjective;
    .item-label {
      background: @blueObjective;
    }
  }
  &.heading-3rd {
    border-color: @purpleObjective;
    .item-label {
      background: @purpleObjective;
    }
  }
}
</style>
